@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}

<ws-modal-wrapper headerLabel="Appeal Email Template"
                  acceptLabel="Save"
                  [excludeModalStyling]="true"
                  [disableSave]="!canSave()"
                  [acceptHelpContentId]="saveHelpId"
                  cancelHelpContentId="app.cancel"
                  (save)="save()"
                  (cancel)="cancel()">
    <div class="row">
        <div class="col-lg-12">
            <div class="mb-3">
                <label for="name">Name:</label>
                <input
                    type="text"
                    class="form-control"
                    id="name"
                    placeholder="Name"
                    maxlength="100"
                    autocomplete="off"
                    [(ngModel)]="name"/>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <div class="mb-3">
                <label for="description">Description:</label>
                <input
                    id="description"
                    type="text"
                    class="form-control"
                    placeholder="Description"
                    maxlength="100"
                    [(ngModel)]="description"/>
            </div>
        </div>
    </div>
    @if (hasEditSystemSearch) {
        <div class="row">
            <div class="col-lg-12">
                <div class="mb-3">
                    <label for="visibility">Visibility:</label>
                    <select id="visibility"
                            class="form-select form-select-sm"
                            [(ngModel)]="visibility"
                            [disabled]="!!params.selectedTemplate">
                        @for (v of visibilities; track v) {
                            <option [ngValue]="v">{{ v.name }}</option>
                        }
                    </select>
                    <div class="ag-grid-layout-specification-details-visibility-description small">
                        {{ visibility?.description }}
                    </div>
                </div>
            </div>
        </div>
    }
</ws-modal-wrapper>
